import { render, staticRenderFns } from "./Disabled.vue?vue&type=template&id=635617ec&"
import script from "./Disabled.vue?vue&type=script&lang=js&"
export * from "./Disabled.vue?vue&type=script&lang=js&"
import style0 from "./Disabled.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports